// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bsY5","type":"styles_type__1X_LK","choices":"styles_choices__1gOv8"};